import React, { useEffect, useState } from 'react';
import { throttle } from 'lodash';
import cx from 'classnames';

import './styles/small-header.scss';

import Logo from '@components/logo/logo';
import { t } from '@i18n/i18n';
import headerTranslations from '@i18n/translations/components/header/header.json';

import LangA from '../../i18n/LangA';
import { useI18nInitNamespace } from '../../i18n/useI18nInitNamespace';
import Promotions from '../promotions/promotions';
import OldPromo from '../PromoBanner/OldPromoBanner';
import StickyHighlightStripAB from '../StickyStrip/stickyHighlightStripAB';
import ABHeader from './ABHeader/ABHeader';

const SmallHeader = ({ isHomepage = false, hasPromo = '', registerUrlDestination = '', stickyAB = { translations: [], pageUrl: '' } }) => {
  useI18nInitNamespace('header', headerTranslations, true);

  const [prevScrollPos, setPrevScrollPos] = useState(0);
  const [visible, setVisible] = useState(false);

  let handleScroll = null;

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollPos = window.pageYOffset;

      setVisible(prevScrollPos > currentScrollPos);
      setPrevScrollPos(currentScrollPos);
    };

    const throttled = throttle(handleScroll, 500, { leading: true, trailing: true });
    window.addEventListener('scroll', throttled);

    return () => window.removeEventListener('scroll', throttled);
  }, [prevScrollPos, visible, handleScroll]);

  useEffect(() => {
    if (window.pageYOffset !== 0) {
      setVisible(false);
      setPrevScrollPos(window.pageYOffset);
    }
  }, []);

  return (
    <header
      className={cx('header', {
        'is-visible': visible && prevScrollPos > 0,
        'is-hidden-navbar': !visible && prevScrollPos > 0,
        'sticky-header': stickyAB.pageUrl,
      })}
      id="header"
    >
      {!hasPromo && <Promotions />}
      {hasPromo && hasPromo === 'A' && <OldPromo />}
      <div className="shell-alt">
        <div className="header__inner">
          <div className="header__content">
            <div className="small-nav-register">
              <Logo id="navigation_zb_logo" />
              <div className="navigation_flex">
                <ABHeader registerUrlDestination={registerUrlDestination} isAuthenticated={false} />

                {/* <LangA id="navigation_register_button" href={registerUrlDestination} className="btn btn--primary is-small">
                  {t('a_Sign_Up_Free')}
                </LangA> */}
              </div>
            </div>
          </div>
        </div>
      </div>
      {stickyAB.pageUrl && <StickyHighlightStripAB translations={stickyAB.translations} pageUrl={stickyAB.pageUrl} />}
    </header>
  );
};

export default SmallHeader;
